





























































































import {Vue, Component} from 'vue-property-decorator'
import SwapLoadingTransactionStep from '@/components/SwapLoadingTransactionStep.vue'
import SwapSwappedStep from '@/components/SwapSwappedStep.vue'
import SwapUnexpectedErrorStep from '@/components/SwapUnexpectedErrorStep.vue'
import {GetGasStep} from '@/enums/GetGasStep'
import {$} from '@/facade'
import {NeoHelper} from '@/helpers/NeoHelper'
import {getN3InvocationBuilder} from '@/model/wallets/invocationsBuilder'

@Component({
  components: {
    SwapLoadingTransactionStep,
    SwapSwappedStep,
    SwapUnexpectedErrorStep,
  },
  computed: {
    GetGasStep() {
      return GetGasStep
    },
  },
})
export default class GetGasModal extends Vue {
  currentStep: GetGasStep = GetGasStep.WAITING_SIGNATURE

  transactionHash: string | null = null

  get canBeClosed() {
    return (
      this.currentStep !== GetGasStep.WAITING_SIGNATURE &&
      this.currentStep !== GetGasStep.VALIDATING_TRANSACTION
    )
  }

  async openEvent({
    amountToUse,
    amountToReceive,
  }: {
    amountToUse: string
    amountToReceive: string
  }) {
    try {
      if (!$.walletAdapter.n3Address) {
        throw new Error('No connected wallet')
      }
      const n3InvocationBuilder = getN3InvocationBuilder()
      const swapNeoUsingNeoProxyInvocationBuilder = n3InvocationBuilder.swapNeoUsingNeoProxyInvocation(
        {
          address: $.walletAdapter.n3Address,
          gasAmountOutMin: amountToReceive,
          neoAmountIn: amountToUse,
        }
      )
      const transactionHash = await $.walletAdapter.invokeN3Wallet(
        swapNeoUsingNeoProxyInvocationBuilder
      )

      this.transactionHash = transactionHash

      this.currentStep = GetGasStep.VALIDATING_TRANSACTION

      const isTransactionValid = await NeoHelper.validateTransaction(
        transactionHash
      )

      if (!isTransactionValid) throw new Error()

      this.currentStep = GetGasStep.SWAPPED
    } catch (error) {
      this.currentStep = GetGasStep.UNKNOWN_ERROR
    }
  }

  closeEvent() {
    this.transactionHash = null
    this.currentStep = GetGasStep.WAITING_SIGNATURE
  }
}
